<template>
  <div class="d-flex align-items-center pb-9">
    <div class="d-flex flex-column flex-grow-1">
      <a href="#" class="text-dark-75 text-hover-primary mb-1 font-size-lg font-weight-bolder"
      >{{ $t(label) || 'N/A' }}</a>
    </div>
    <span
        class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
    >{{ count || 0 }}</span>
  </div>
</template>
<script>
export default {
  name: 'count-label',
  props: {
    label: String,
    count: Number,
  }
}
</script>
